import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M18.594 6.375H5.406C4.63 6.375 4 7.008 4 7.781v8.438c0 .777.634 1.406 1.406 1.406h13.188c.77 0 1.406-.626 1.406-1.406V7.78c0-.771-.627-1.406-1.406-1.406m-.197.938-5.403 5.374a1.4 1.4 0 0 1-.994.411c-.376 0-.729-.146-.995-.412L5.603 7.313zm-13.46 8.715V7.973l4.052 4.03zm.667.66 4.05-4.024.689.685a2.33 2.33 0 0 0 1.657.687c.626 0 1.215-.244 1.656-.686l.69-.686 4.05 4.024zm13.459-.66-4.052-4.025 4.052-4.03z" }, null, -1)
  ])))
}
export default { render: render }